import React, { useState, useEffect } from "react";
import { DefaultWidgetContextMenu } from "../../components/DefaultWidgetContextMenu";
import { FloatingLabelContainer } from "../../components/FloatingLabel";

// Externals
import cn from "classnames";

//DevExtreme components
import { SelectBox } from 'devextreme-react';

// Component styles
import classes from "./DropdownWidget.module.scss";

const EMPTY = null;

export function DropdownWidget(props) {
  const { ui, data, config, writeBack, getContextActions, useFloatingLabel } = props;

  const [localContent, setLocalContent] = useState(EMPTY);
  const [hasFocus, setHasFocus] = useState(false);

  let widgetId = ui.id;
  let content = localContent !== EMPTY ? localContent : data && data.content ? JSON.parse(data.content) : null;
  let currentValue = content ? content.CurrentItemId : "";
  let selectionCandidates = (content ? content.SelectionCandidates : null) || (config ? config.SelectionCandidates : null);
  let disabled = ui.readonly || (data && data.readonly);

  useEffect(() => {
    // console.log("DropdownWidget data of " + ui.id + ": ", data);
    setLocalContent(EMPTY);
  }, [data]);

  const setContent = value => {
    setLocalContent({ CurrentItemId: value });
    writeBack(value, true);
  };

  const handleOnCopy = () => {
    return currentValue;
  };

  const handleOnPaste = (value) => {
    setLocalContent({ CurrentItemId: value });
    writeBack(value, true);
  };

  const handleOnDelete = () => {
    setLocalContent(null);
    writeBack(null, true);
  };

  return (
    <DefaultWidgetContextMenu
      widgetId={widgetId}
      getContextActions={getContextActions}
      onCopy={handleOnCopy}
      onPaste={handleOnPaste}
      onDelete={handleOnDelete}
      editable={!disabled}
    >
      <FloatingLabelContainer condition={useFloatingLabel} widgetId={widgetId} hasContent={currentValue} hasFocus={hasFocus} text={ui.label}>
        <SelectBox
          id={widgetId}
          className={cn(useFloatingLabel ? classes.withFloatingLabel : "", disabled ? classes.disabled : "")}
          value={(selectionCandidates && selectionCandidates.length > 0) ? currentValue : ""}
          onFocusOut={() => setHasFocus(false)}
          onFocusIn={() => setHasFocus(true)}
          dataSource={selectionCandidates}
          placeholder=""
          displayExpr="DisplayData"
          valueExpr="ItemId"
          searchEnabled={true}
          searchMode="startswith"
          searchExpr="DisplayData"
          minSearchLength={2}
          showDataBeforeSearch={true}
          onValueChanged={e => setContent(e.value)}
          disabled={disabled}
          height={ui.controlHeight + "em"}
        />
      </FloatingLabelContainer>
    </DefaultWidgetContextMenu>
  );
}
